import { COLOR, FONT_WEIGHT, Heading as _Heading, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivAttentionWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 240px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${COLOR.GRAY200.code};
`;

export const Heading = styled(_Heading)`
  font-weight: ${FONT_WEIGHT.BOLD};
  margin-bottom: 8px;
  color: ${COLOR.GRAY900.code};
`;

export const ParText = styled.p`
  font-size: 14px;
  color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    font-size: 12px;
  }
`;

export const UlWrapper = styled.ul`
  padding: 8px;
`;

export const List = styled.li`
  font-size: 14px;
  color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    font-size: 12px;
  }
`;
